import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { REVIEWS } from "@/data/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Reviews() {
  return (
    <section id="recensioni" data-testid="reviews-section" className="bg-blush-50/60 py-28 lg:py-40">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.4em] text-blush-500"
        >
          <span className="h-px w-10 bg-blush-500" />
          Dicono di noi
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
          className="max-w-2xl font-serif text-4xl leading-tight text-ink sm:text-5xl lg:text-6xl"
        >
          Clienti <span className="italic text-blush-500">felici</span>, sempre.
        </motion.h2>

        <div className="mt-20 grid grid-cols-1 gap-8 md:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
              className={`flex flex-col rounded-2xl border border-blush-100 bg-cream p-10 transition-shadow duration-500 hover:shadow-xl hover:shadow-blush-100/70 ${i === 1 ? "md:-translate-y-8" : ""}`}
            >
              <Quote size={26} className="text-blush-500" />
              <p className="mt-6 flex-1 font-serif text-xl italic leading-relaxed text-ink">
                “{r.text}”
              </p>
              <footer className="mt-8">
                <div className="flex gap-1" aria-label="5 stelle">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} size={14} className="fill-blush-500 text-blush-500" />
                  ))}
                </div>
                <p className="mt-4 text-sm font-semibold text-ink">{r.name}</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.3em] text-ink-soft">{r.service}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
